import React from 'react'
import { ComponentExt } from 'util/reactExt'
import { Menu, Table, Select } from 'antd'
import styles from './index.scss'
import LineChart from 'containers/shared/LineChart'
import ICompareWithExampleChart from './ICompareWithExampleChart'
import ICompareWithToptenChart from './ICompareWithToptenChart'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import Breadcrumb from 'components/Breadcrumb'

const Option = Select.Option
const currentYear = new Date().getFullYear()
const yearList = Array(currentYear - 2018 + 1)
  .fill(0)
  .map((_, i) => String(2018 + i))
  .reverse()

const studyMinsFormatter = min =>
  min ? Math.round((Number(min) / 60) * 100) / 100 : 0

const percentFormatter = percent =>
  percent ? Math.round(Number(percent) * 100 * 100) / 100 : 0

const JZICompareWithExampleChart: any = ICompareWithExampleChart

interface UStudyDataProps extends RouteComponentProps<any> {}

class UStudyData extends ComponentExt<UStudyDataProps> {
  filedsTextMap = {
    sysStudyNum: '系统平均学习数量',
    myStudyNum: '个人平均学习数量',
    sysStudyHour: '系统平均学习时长',
    myStudyHour: '个人平均学习时长',
    sysStudyPercent: '系统视频完成度(%)',
    myStudyPercent: '个人视频完成度(%)',
  }

  MenuRenderMap = {
    example: <JZICompareWithExampleChart />,
    topten: <ICompareWithToptenChart />,
  }

  state = {
    loading: false,
    currentTablePage: 1,
    myStudyData: [],
    myStudyTrendData: [],
    currentComparison: 'example',
  }

  componentDidMount() {
    this.fetchStudyData({ year: currentYear, staffid: this.staffid })
    this.fetchStudyTrendData({ staffid: this.staffid })
  }

  async fetchStudyData({ year, staffid }) {
    this.setState({ loading: true, myStudyData: [] })

    const my = await this.api.user.getUserStudyData({ year, staffid })
    const myStudyData = []

    for (const val of my) {
      myStudyData.push({
        ...val,
        month: val.the_date.split('-')[1],
        study: studyMinsFormatter(val.study),
        finish_percent: percentFormatter(val.finish_percent),
      })
    }

    this.setState({
      myStudyData,
    })

    this.setState({ loading: false })
  }

  async fetchStudyTrendData({ staffid }) {
    const { my, sys } = await this.api.user.getUserStudyTrendData({
      staffid,
    })
    const myStudyTrendData = []
    const {
      sysStudyNum,
      sysStudyHour,
      myStudyNum,
      myStudyHour,
      sysStudyPercent,
      myStudyPercent,
    } = this.filedsTextMap

    my.forEach((val, key) => {
      myStudyTrendData.push({
        month: val.the_date,
        [myStudyNum]: val.avg_articles,
        [myStudyHour]: studyMinsFormatter(val.avg_study),
        [myStudyPercent]: percentFormatter(val.finish_percent),
        [sysStudyNum]: sys[key].avg_articles,
        [sysStudyHour]: studyMinsFormatter(sys[key].avg_study),
        [sysStudyPercent]: percentFormatter(sys[key].finish_percent),
      })
    })

    this.setState({
      myStudyTrendData,
    })
  }

  handleChange = year => {
    this.setState({ currentTablePage: 1 })
    this.fetchStudyData({ year, staffid: this.staffid })
  }

  handleChangeComparisonClick = ({ key }) => {
    this.setState({
      currentComparison: key,
    })
  }

  handleChangeSectionClick = ({ key }) => {
    this.setState({
      currentSection: key,
    })
  }

  handleChangeTablePage = page => {
    this.setState({
      currentTablePage: page,
    })
  }

  get name() {
    return new URLSearchParams(this.props.location.search).get('name')
  }

  get staffid() {
    return new URLSearchParams(this.props.location.search).get('staffid')
  }

  // 我的学习数据报表
  renderMyStudyTable = myStudyData => {
    const columns = [
      {
        title: '月份',
        dataIndex: 'month',
        className: 'columnCenter',
      },
      {
        title: '总学习时长(小时)',
        className: 'columnCenter',
        dataIndex: 'study',
      },
      {
        title: '视频学习数',
        className: 'columnCenter',
        dataIndex: 'articles',
      },
      {
        title: '视频完成度(%)',
        className: 'columnCenter',
        dataIndex: 'finish_percent',
        render: text => <span style={{ color: '#FF3C00' }}>{text}</span>,
      },
    ]
    return (
      <section>
        <h4 className={styles.chartTitle}>
          <span>{this.name ? 'TA' : '我'}的学习数据报表</span>
          <Select
            defaultValue={String(currentYear)}
            onChange={this.handleChange}
            style={{ width: 100, marginLeft: 24 }}
          >
            {yearList.map(y => (
              <Option key={y} value={y}>
                {y}
              </Option>
            ))}
          </Select>
        </h4>
        <Table
          loading={this.state.loading}
          columns={columns}
          dataSource={myStudyData}
          bordered
          pagination={{
            current: this.state.currentTablePage,
            defaultPageSize: 6,
            onChange: this.handleChangeTablePage,
            hideOnSinglePage: true,
          }}
        />
      </section>
    )
  }

  // 我的学习趋势图
  renderMyStudyTrendChart = myStudyTrendData => {
    return (
      <section>
        <h4 className={styles.chartTitle}>
          {this.name ? 'TA' : '我'}的学习趋势图
        </h4>
        <LineChart data={myStudyTrendData} filedsTextMap={this.filedsTextMap} />
      </section>
    )
  }

  renderBreadcrumbs = () => {
    return this.staffid ? (
      <Breadcrumb
        data={[
          { name: '学习力数据', url: '/usercenter/data/my' },
          { name: `${this.name}`, url: '' },
        ]}
      />
    ) : null
  }

  render() {
    const { myStudyData, myStudyTrendData, currentComparison } = this.state

    return (
      <div className={styles.myStudyData}>
        {this.renderBreadcrumbs()}
        {this.renderMyStudyTrendChart(myStudyTrendData)}
        {this.renderMyStudyTable(myStudyData)}
        <section>
          <Menu
            onClick={this.handleChangeComparisonClick}
            selectedKeys={[currentComparison]}
            mode="horizontal"
          >
            <Menu.Item key="example">
              {this.name ? 'TA' : '我'}与榜样的对比
            </Menu.Item>
            <Menu.Item key="topten">
              {this.name ? 'TA' : '我'}与系统前十的对比
            </Menu.Item>
          </Menu>
          {this.MenuRenderMap[currentComparison]}
        </section>
      </div>
    )
  }
}

export default withRouter(UStudyData)
